const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onFavoriteClick: {
      to: "/"
    },
    onComparisonClick: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
